<script lang="ts">
import WinnerCard from '@/components/cards/WinnerCard.vue'
import { useWinnersStore } from '@/stores/winners'
import type { Winner } from '@/types'
import { PrizeResultCategories } from '@/utils/helper-objects'
import { defineComponent } from 'vue'

import AppCarousel from '../carousel/AppCarousel.vue'
import CarouselItem from '../carousel/CarouselItem.vue'

/**
 * Winners Section.
 */
export default defineComponent({
  components: {
    WinnerCard,
    AppCarousel,
    CarouselItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const winnersStore = useWinnersStore()
    return {
      winnersStore,
      PrizeResultCategories,
    }
  },
  data() {
    return {
      winners: [] as Array<Winner>,
      upgradePlan: this.$plansStore.getPlanByTier(
        'vip',
        this.$userStore.highestPlan?.period
      ),
    }
  },
  async mounted() {
    await this.winnersStore.fetchWinners()
    this.winners = this.winnersStore.highlightedWinners
  },
})
</script>

<template>
  <AppSection class="dark-section !mb-0">
    <div class="px-3 @md/main:px-8">
      <AppCarousel
        :icon="Icons.Trophy"
        :title
        :view-all-route="{
          name: 'results-and-winners',
          hash: '#' + PrizeResultCategories.Winners,
        }"
      >
        <template #preamble>
          <slot name="sub-heading"></slot>
        </template>
        <CarouselItem
          v-for="(winner, key) in winners"
          :key
          class="w-[306px] max-w-[100%]"
        >
          <WinnerCard :winner class="h-full" />
        </CarouselItem>
      </AppCarousel>
    </div>

    <AppUpgradeModal
      v-if="
        $userStore.showUpgradePlan &&
        $userStore.highestPlan &&
        $userStore.vipPlan
      "
      :user-plan="$userStore.highestPlan"
      :upgrade-plan="$userStore.vipPlan"
    />
    <SectionGuard section="memberships">
      <AppMembershipButton v-if="$userStore.isLoggedOut" />
    </SectionGuard>
  </AppSection>
</template>
